import React from 'react';
import DrawerButton from '../Button/DrawerButton';
import { H4 } from '@/components/Element/Heading';

const CTACard = () => {
  return (
    <div className="flex space-x-4 text-sm text-gray-500">
      <div className="space-y-6 max-w-xl text-center mx-auto py-10 border-t border-gray-200">
        <H4 className="capitalize text-black">
          Ready to experience the best in solar energy for your home?
        </H4>
        <p className="prose-sm prose text-gray-500 max-w-none">
          EnergyPal is a dealer for the best Solar Panels and leading energy
          companies, solar installers and manufacturers of solar and battery
          storage products. To see our latest deals, and learn about financing
          and $0 down lease options, please request a quote and we will call you
          immediately.
        </p>
        <DrawerButton>Get Started</DrawerButton>
      </div>
    </div>
  );
};

export default CTACard;
